"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledColumnContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledColumnContainer = styled_components_1.default.div `
  align-items: ${(props) => (props.left ? 'flex-start' : 'flex-end')}};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
`;
